import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Button, Select } from "antd";
import { createJackpot } from "../../features/jackpot/jackpotSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
const { Option } = Select;

const CreateJackpot = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, creating, message, isCreateSuccess } = useSelector(
    (state) => state.jackpot
  );

  const onFinish = (data) => {
    data.type = "hole-in-one";
    dispatch(createJackpot(data));
  };

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isCreateSuccess) {
      messageApi.open({
        type: "success",
        content: "Jackpot created successfully",
      });
    }

    if (isCreateSuccess) {
      navigate("/admin/hole-in-one-prize");
    }
  }, [isError, message, isCreateSuccess, messageApi, navigate]);

  const [prizeType, setPrizeType] = useState("cash");

  const handlePrizeTypeChange = (value) => {
    console.log(value);
    setPrizeType(value);
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Challenge</h3>
      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ period: "day", status: "1", type: "hole-in-one", prize_type: "cash", entry_price: 0 }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Prize Type"
          name="prize_type"
          rules={[{ required: true, message: "Please select the prize type!" }]}
        >
          <Select onChange={handlePrizeTypeChange}>
            <Option value="cash">Cash</Option>
            <Option value="item">Item</Option>
          </Select>
        </Form.Item>

        {prizeType === "item" ? (
          <Form.Item
            label="Winning Item"
            name="winning_item"
            rules={[
              { required: true, message: "Please input the winning item!" },
            ]}
          >
            <Input />
          </Form.Item>
        ) : (
          <Form.Item
            label="Winning Price"
            name="winning_price"
            rules={[
              { required: true, message: "Please input the winning price!" },
            ]}
          >
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        )}

        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please input the description!" }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Points"
          name="points"
          rules={[{ required: true, message: "Please input the points!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
                
        <Form.Item
          label="Entry Price"
          name="entry_price"
          rules={[{ required: false, message: 'Please input the entry price!' }]}
        >
          <InputNumber min={1} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={creating}>
            {creating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateJackpot;
